import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const CARD_SELECTOR =
  '[class*="card"], [class*="package"], [class*="feature"], [class*="step"]';

export default function PageMotion() {
  const location = useLocation();

  useEffect(() => {
    const prefersReducedMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)"
    ).matches;

    if (prefersReducedMotion) {
      return undefined;
    }

    const sectionElements = Array.from(document.querySelectorAll("section"));
    const cardElements = Array.from(document.querySelectorAll(CARD_SELECTOR));

    const revealElements = [...new Set([...sectionElements, ...cardElements])];

    revealElements.forEach((element, index) => {
      element.classList.remove(
        "motion-in",
        "motion-up",
        "motion-left",
        "motion-right"
      );
      element.classList.add("motion-reveal");

      if (cardElements.includes(element)) {
        element.classList.add("motion-card");
        element.classList.add(index % 2 === 0 ? "motion-left" : "motion-right");
        element.style.setProperty("--motion-delay", `${(index % 8) * 50}ms`);
      } else {
        element.classList.add("motion-up");
      }
    });

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("motion-in");
            observer.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.15,
        rootMargin: "0px 0px -8% 0px",
      }
    );

    revealElements.forEach((element) => observer.observe(element));

    return () => {
      observer.disconnect();
    };
  }, [location.pathname, location.hash]);

  return null;
}
